module.exports = __webpack_public_path__ + "static/media/improvement-initiatives-ebitda.50216ac9.png";